import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    dialogContainer: {
        borderRadius: 'var(--border-radius)'
    },
    dialogTitleRoot: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    dialogDeleteAlertTitle: {
        fontSize: 20
    }
}))
